import React from "react";
import "./styles.css";

export default function App() {
  return (
    <div className="App">
      <h1>Hello Codeforces</h1>
      <h2>Check our Blogs, !</h2>
    </div>
  );
}
